import React, {useState} from 'react';
import cx from 'classnames';
import {Button, Icon, noop, PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from '../../texts';
import {SearchSaveButton} from './parts/SearchSaveButton/SearchSaveButton';
import {createDataTestId} from '../../../../../../../utils/dataTestId';
import {SearchTitleBox} from './parts/SearchTitleBox';
import {PatchSavedSearch} from '../../index';
import styles from '../../styles.module.scss';

type Props = {
    onClear: () => void;
    showExportBtn: boolean;
    isDisabled: boolean;
    search: PatchSavedSearch;
    onSearch: (search: PatchSavedSearch) => void;
    onSaveAndSearch: (search: PatchSavedSearch) => void;
    isSavedSearch: boolean;
};

export const AdvancedSearchFooter = (props: Props) => {
    const {showExportBtn, isDisabled, search, isSavedSearch, onClear, onSearch, onSaveAndSearch} =
        props;
    const [isSaveView, toggleSaveView] = useState(false);

    const showClearButton = search?.filters?.length > 0;

    const onSearchTitleSave = async (name: string) => {
        onSaveAndSearch({...search, name});
        toggleSaveView(false);
    };

    return (
        <div className={cx(styles.footer)} {...createDataTestId('advanced-search-footer', false)}>
            {isSaveView ? (
                <SearchTitleBox
                    onSearchTitleSave={onSearchTitleSave}
                    onClose={() => toggleSaveView(false)}
                    isDisabled={isDisabled}
                />
            ) : (
                <>
                    {showClearButton ? (
                        <Button
                            size="large"
                            skin="text"
                            prefixIcon={PriorityIcon.clear}
                            onClick={onClear}
                            disabled={isDisabled}
                        >
                            {texts.clearSearch}
                        </Button>
                    ) : (
                        <span></span>
                    )}

                    <div className={styles.footerBtnContainer}>
                        {showExportBtn ? (
                            <Button
                                componentClasses={styles.export}
                                disabled={isDisabled}
                                size="medium"
                                skin="text"
                                prefixIcon={
                                    <Icon
                                        onClick={noop}
                                        icon={PriorityIcon.exportExcel}
                                        componentClasses={styles.iconExport}
                                    />
                                }
                            >
                                {texts.export}
                            </Button>
                        ) : null}

                        {!isSavedSearch ? (
                            <Button
                                componentClasses={styles.saveBtn}
                                size="medium"
                                skin="secondary"
                                onClick={() => toggleSaveView(true)}
                                disabled={isDisabled}
                            >
                                {texts.save}
                            </Button>
                        ) : null}

                        <SearchSaveButton
                            search={search}
                            disabled={isDisabled}
                            searchAction={onSearch}
                            saveAndSearch={onSaveAndSearch}
                            isSavedSearch={isSavedSearch}
                            addToResultsAction={() => {}}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
